import $ from "jquery";

export default class FiltreActivites {
  constructor() {
    this.radioButtons = document.querySelectorAll(".filter-selector");
    this.resetButton = document.getElementById("resetSelectorActivities");

    if ((this.radioButtons != undefined && this.resetButton != undefined) && (this.radioButtons && this.resetButton)) {
      const activitiesCount = document.querySelectorAll(".activity.item-search-activity").length;
      this.displayResultsCount(activitiesCount);
      // Écouter les changements de sélection des radio boutons
      this.radioButtons.forEach((button) => {
        button.addEventListener("change", this.handleFilterChange);
      });

      $('a.seeResults').on("click", function(){
        $("html, body").animate(
          {
            scrollTop: $('.activities-list').offset().top - 50,
          },
          1000
        );
      });
      $('.seeResults .total').text(activitiesCount);
      // Écouter le clic sur le bouton de réinitialisation
      this.resetButton.addEventListener("click", this.handleReset);
    }



  }
  

  handleFilterChange = (event) => {
    const selectedValue = event.target.value;
    const filterName = event.target.name;

    // Afficher ou masquer les filtres en fonction des sélections
    if (filterName === "je-viens") {
      // En famille ou entre amis sélectionné, afficher le filtre âge
      if (selectedValue === "activiteFamille" || selectedValue === "activiteAmis") {
        $(".filter.age").slideDown(500);
      } else {
        $(".filter.age").slideUp(500);
      }
    } else if (filterName === "nuitee") {
      // Je loge sélectionné, afficher le filtre Nous réservons
      if (selectedValue === "activiteNuitee") {
        $(".filter.nous-reservons").slideDown(500);
      } else {
        $(".filter.nous-reservons").slideUp(500);
      }
    } else if (filterName === "jeu") {
      // Je joue sélectionné, afficher les filtres niveau de jeu, espace de jeu souhaité et groupe de jeu
      if (selectedValue === "activiteJeu") {
        $(".filter.niveau-jeu, .filter.espace-de-jeu-souhaite, .filter.groupe-de-jeu").slideDown(500);
      } else {
        $(".filter.niveau-jeu, .filter.espace-de-jeu-souhaite, .filter.groupe-de-jeu").slideUp(500);
      }
    }

    // Afficher ou masquer les activités en fonction des sélections
    const activities = document.querySelectorAll(".activity.item-search-activity");
    const noActivities = document.querySelectorAll(".noactivities");
    let activitiesFound = false; // Variable pour indiquer si des activités ont été trouvées
    let countActivities = 0;
    activities.forEach((activity) => {
      const shouldShowActivity = this.shouldShowActivity(activity);

      if (shouldShowActivity) {
        $(activity).slideDown(500);
        activitiesFound = true; // Définir la variable à true si au moins une activité est affichée
        countActivities++;
      } else {
        $(activity).slideUp(500);
      }

      // Vérifier si aucune activité n'a été trouvée
      if (!activitiesFound) {
        $(noActivities).slideDown(500); // Afficher le contenu de la variable noActivities
      } else {
        $(noActivities).slideUp(500); // Masquer le contenu de la variable noActivities s'il y a des activités trouvées
      } 
    });
    this.displayResultsCount(countActivities);
    
  };

  displayResultsCount = (countActivities) => {
    let resultCount = $('.seeResults .nbrResults');
    let resultTextSingle = $('.seeResults .single');
    let resultTextMultiple = $('.seeResults .multiple');
    resultCount.text(countActivities)
    if(countActivities && countActivities > 1){
      resultTextSingle.hide();
      resultTextMultiple.show();
    }else{
      resultTextSingle.show();
      resultTextMultiple.hide();
    }
    $('.seeResults').addClass('tilt');
    setTimeout(() => {
      $('.seeResults').removeClass('tilt');
    }, "1000");
  }

  shouldShowActivity = (activity) => {
    const filters = document.querySelectorAll(".filter-selector");
    let shouldShow = true;

    filters.forEach((filter) => {
      const filterValue = filter.value;

      if (filter.checked && activity.dataset[filterValue] !== "on") {
        shouldShow = false;
        return;
      }
    });

    return shouldShow;
  };

  handleReset = () => {
    let activitiesCount = document.querySelectorAll(".activity.item-search-activity").length;
    // Réinitialiser tous les boutons radio
    this.radioButtons.forEach((button) => {
      button.checked = false;
    });

    // Réafficher tous les filtres
    $(".filter.age, .filter.niveau-jeu, .filter.espace-de-jeu-souhaite, .filter.groupe-de-jeu, .filter.nous-reservons").slideUp(500);

    // Afficher toutes les activités
    const activities = document.querySelectorAll(".activity.item-search-activity");
    activities.forEach((activity) => {
      $(activity).slideDown(500);
    });
    this.displayResultsCount(activitiesCount);
  }; 
}